import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
//import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollToPlugin,ScrollTrigger);
import picturefill from 'picturefill';
import svgxuse from 'svgxuse';
import { Pamphlet } from './Pamphlet';
import { ContentsList } from './ContentsListEN';
import { Zoom } from './Zoom';
import { Language } from './Language';

const zoom = new Zoom();
const pamph = new Pamphlet(zoom);
const contentsList = new ContentsList(pamph);
const language = new Language();

const book = document.querySelector('.book');
const btnNext = document.querySelector('.js-turn-next');
const btnPrev = document.querySelector('.js-turn-prev');
const menu = document.querySelector('.js-menu');

const getParam = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

if(Boolean(getParam('outline'))) {
    document.querySelector('body').classList.add('outline');
}




window.addEventListener('contextmenu',(e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
})

document.onselectstart = function(){ return false; };
document.onmousedown = function(){ return false; };
document.body.onselectstart = "return false;"
document.body.onmousedown = "return false;"

document.body.addEventListener("touchstart", function(e){
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  }, {passive: false});
  document.body.addEventListener("touchmove", function(e){
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  }, {passive: false});

/*const zoomInit = () => {
    if(btnZoom.classList.contains('out')) {
        btnZoom.classList.remove('out');
        textZoom.innerHTML = '拡大';
    }
}*/

//book.addEventListener('pageload',zoomInit);

btnNext.addEventListener('click',() => {
    pamph.pageNext();

});
btnPrev.addEventListener('click',() => {
    pamph.pagePrev();
});

/*btnZoom.addEventListener('click',() => {
});*/

menu.addEventListener('click',() => {
    contentsList.open();
});


/*btnToc.addEventListener('click',() => {
    contentsList.open();
})*/



/*btnZoomOut.addEventListener('click',()=> {
    pamph.zoomOut();
})*/